import api from './utilBackoffice';

const controller = 'PropostaModalidadeAusente3044';
const url = process.env.VUE_APP_ROOT_API + controller;

export default Object.assign({}, api.GetCrud(controller, null), {
  GetAllPaged: dto => {
    return api.Axios.GetParams(url, dto);
  },
  GetResumoDashboard: dto => {
    return api.Axios.GetParams(url + '/GetResumoDashboard', dto);
  }
});
